module.exports = "\n<div class=\"loader\"  *ngIf=\"visible\" [style.width]=\"width\" [style.zIndex]=\"zIndex\">\n\tLoading...\n\t<div class=\"spinner\">\n\t  <div class=\"double-bounce1\"></div>\n\t  <div class=\"double-bounce2\"></div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = 1119
// module chunks = 0 1 2 3 4 5 6 7